const newContainer = () => import("@/layouts/Default.vue");
const myTicketsList = () => import("../views/my-tickets/myTicketsList.vue");
const myTicketDetail = () => import("../views/my-tickets/myTicketDetail.vue");
const addMyTicket = () => import("../views/add-my-ticket/addMyTicket.vue");
const allTicketList = () => import("../views/all-tickets/allTicketsList.vue");
const allTicketDetail = () =>
  import("../views/all-tickets/allTicketsDetail.vue");
const contactUsList = () => import("../views/contact-us/contactUsList.vue");
const contactUsDetail = () => import("../views/contact-us/contactUsDetail.vue");
const ticketAccessList = () =>
  import("../views/ticket-access/TicketAccessList.vue");

export const ticketRoutes: any[] = [
  {
    meta: {
      label: "خانه",
      moduleName: "ticket",
    },
    path: "/ticket",
    name: "task",
    component: newContainer,
    children: [
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "my-ticket",
        name: "user_ticket_search",
        redirect: "/ticket/my-ticket/list",
        children: [
          {
            path: "list",
            name: "my-ticket-list",
            component: myTicketsList,
            meta: {
              label: "درخواست‌های من",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "add",
            name: "user_add_ticket",
            component: addMyTicket,
            meta: {
              label: "ثبت درخواست جدید",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: ":code/detail",
            name: "my-ticket-detail",
            component: myTicketDetail,
            meta: {
              label: "جزییات درخواست",
              requiresAuth: true,
              redesigned: true,
            },
          },
          {
            path: "add-ticket-by-operator",
            name: "operator_add_ticket",
            // component: addTicketByOperator,
            meta: {
              label: "ایجاد درخواست جدید توسط پشتیبان",
              requiresAuth: true,
            },
          },
          {
            path: "protest",
            name: "add_protest_ticket",
            // component: addTicket,
            meta: {
              label: "ثبت اعتراض",
              requiresAuth: true,
            },
          },
          {
            path: "faq",
            name: "faqPage",
            // component: faqPage,
            meta: {
              label: "سوال‌های متداول",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "all-ticket",
        name: "all_ticket_search",
        redirect: "/ticket/all-ticket/list",
        children: [
          {
            meta: {
              label: "بررسی درخواست‌ها",
              requiresAuth: true,
              redesigned: true,
            },
            path: "list",
            name: "all-ticket-list",
            component: allTicketList,
          },
          {
            meta: {
              label: "ویرایش درخواست ",
              requiresAuth: true,
              redesigned: true,
            },
            path: ":code/detail",
            name: "all-ticket-detail",
            component: allTicketDetail,
          },
          {
            meta: {
              label: "درخواست‌ها بر حسب کاربر",
              requiresAuth: true,
            },
            path: "by-users",
            name: "all_ticket_users_search",
            // component: allTicketUsersSearch,
          },
          {
            meta: {
              label: "ارسال درخواست جدید",
              requiresAuth: true,
            },
            path: "add",
            name: "add_all_ticket",
            // component: addAllTicket,
          },
        ],
      },
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
          redesigned: true,
        },
        path: "ticket-access",
        name: "ticket_access",
        redirect: "/ticket/ticket-access/list",
        children: [
          {
            meta: {
              label: "دسترسی درخواست‌ها",
              requiresAuth: true,
              redesigned: true,
            },
            path: "list",
            name: "ticket-access-list",
            component: ticketAccessList,
          },
        ],
      },
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "contact-us",
        name: "contact_us_search",
        redirect: "/ticket/contact-us/list",
        children: [
          {
            meta: {
              label: "مشکل‌های ورود",
              requiresAuth: true,
              redesigned: true,
            },
            path: "list",
            name: "contact-us-list",
            component: contactUsList,
          },
          {
            meta: {
              label: "ویرایش مشکلات ورود",
              requiresAuth: true,
              redesigned: true,
            },
            path: "edit/:id",
            name: "edit_contact_us",
            component: contactUsDetail,
          },
        ],
      },
    ],
  },
  /* {
      path: '/ticket',
      name: 'user_ticket_search',
      redirect: "/ticket/my-ticket",
      meta: {
        label: "درخواست"
      },
      // component: newContainer,
      children: [
        {
          path: 'my-ticket',
          name: 'user_ticket_search',
          // component: newTicketSearch,
          meta: {
            label: "درخواست‌های من",
            requiresAuth: true
          },
        },
        {
          path: 'addTicket',
          name: 'user_add_ticket',
          // component: addTicket,
          meta: {
            label: "ارسال درخواست جدید",
            requiresAuth: true
          },
        },
        {
          path: 'edit/:code',
          name: 'user_edit_ticket',
          // component: newEditTicket,
          meta: {
            label: "ویرایش درخواست ",
            requiresAuth: true
          },
        },
        {
          path: 'addTicketByOperator',
          name: 'operator_add_ticket',
          // component: addTicketByOperator,
          meta: {
            label: "ایجاد درخواست جدید توسط پشتیبان",
            requiresAuth: true
          },
        },
        {
          path: 'protest',
          name: 'add_protest_ticket',
          // component: addTicket,
          meta: {
            label: "ثبت اعتراض",
            requiresAuth: true
          },
        },
        {
          path: 'faq',
          name: 'faqPage',
          // component: faqPage,
          meta: {
            label: "سوال‌های متداول",
            requiresAuth: true
          },
        },
        {
          path: 'contactUs',
          name: 'contact_us_list',
          redirect: '/support/contactUs/search',
          // component: routerParent,
          meta: {
            label: "درخواست پشتیبانی",
            requiresAuth: true
          },
          children: [
            {
            path: 'search',
            name: 'contact_us_search',
            // component: contactUsSearch,
            meta: {
              label: "لیست در خواست‌ها",
              requiresAuth: true
            },
          },{
            path: 'edit/:id',
            name: 'edit_contact_us',
            // component: editContactUs,
            meta: {
              label: "ویرایش در خواست‌ها",
              requiresAuth: true
            },
          }]
        }
      ]
  }, */
  /* {
    path: '/allticket',
    name: 'all_ticket',
    redirect: "/allticket/allTicketSearch",
    meta: {
      label: "درخواست"
    },
    // component: newContainer,
    children: [
      {
        path: 'addAllTicket',
        name: 'add_all_ticket',
        // component: addAllTicket,
        meta: {
          label: "ارسال درخواست جدید",
          requiresAuth: true
        },
      },
      {
        path: 'allTicketSearch',
        name: 'all_ticket_search',
        // component: newAllTicketSearch,
        meta: {
          label: "لیست درخواست‌ها",
          requiresAuth: true
        },
      },
      {
        path: 'allTicketTUsers',
        name: 'all_ticket_users_search',
        // component: allTicketUsersSearch,
        meta: {
          label: "لیست درخواست‌ها",
          requiresAuth: true
        },
      },
      {
        path: 'edit/:code',
        name: 'edit_all_ticket',
        // component: newEditAllTicket,
        meta: {
          label: "ویرایش درخواست ",
          requiresAuth: true
        },
      },
    ]
  }, */
  /* {
    path: '/ticket-access',
    name: 'ticket_access',
    redirect: "/ticket-access/search",
    meta: {
      label: "دسترسی درخواست‌ها"
    },
    // component: newContainer,
    children: [
      {
        path: 'search',
        name: 'ticket_access_search',
        // component: ticketAccessSearch,
        meta: {
          label: "لیست مشاهده دسترسی‌ها",
          requiresAuth: true
        },
      },
    ]
  }, */
];
